<div class="login-background">
    <form [formGroup]="loginForm">
        <div class="login-form">
            @if (loginFormState === LoginFormState.FillIn || loginFormState === LoginFormState.Error || loginFormState === LoginFormState.Login) {
                <h1 class="h2 condensed">Inloggen</h1>
                <div class="mt-2">
                    @if (loginFormState !== LoginFormState.Login) {
                        <button
                            (click)="loginWithMicrosoft()"
                            class="microsoft-login-btn w-100"
                            [class.highlight]="isDvds"
                            mat-raised-button>
                            <mat-icon fontSet="fa-brands" fontIcon="fa-microsoft"></mat-icon>
                            Inloggen met Microsoft
                        </button>
                    }
                    @if (isDvds) {
                        <div class="info">
                            <b>Gebruik "Inloggen met Microsoft"</b>
                            <p>
                                Voor dvds.nl adressen is "Inloggen met Microsoft" verplicht.
                            </p>
                        </div>
                    }
                </div>
            }
        </div>
    </form>
</div>
